import { createFrameFieldViewer } from "./frameFieldViewer.js";
import type { FrameFieldViewer, FrameFieldConfig, FrameField, FrameFieldViewerOptions } from "./frameFieldViewer.js";

export type AccountViewerFieldConfig = FrameFieldConfig;
export type AccountViewerField = FrameField;
export type AccountViewerOptions = FrameFieldViewerOptions;
export type AccountViewer = FrameFieldViewer;

const DEFAULT_FIELDS = ["accountNumber", "routingNumber"];

export function createAccountViewer(options: AccountViewerOptions): AccountViewer {
  return createFrameFieldViewer("AccountViewer", DEFAULT_FIELDS, options);
}
